import { render, staticRenderFns } from "./sidHeader.html?vue&type=template&id=5034e089&external"
import script from "./sidHeader.vue?vue&type=script&lang=ts"
export * from "./sidHeader.vue?vue&type=script&lang=ts"
import style0 from "./sidHeader.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports